module.exports = __webpack_public_path__ + "static/media/preview_general_campaign_5.68ee1cdc.svg";